import { useEffect } from 'react';
import { createFrontendModule, AppRootElementBlueprint } from '@backstage/frontend-plugin-api';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';

/**
 * Redirects guest users to /tv if they navigate anywhere else.
 */
function GuestRouteGuard() {
  const identityApi = useApi(identityApiRef);

  useEffect(() => {
    const check = async () => {
      try {
        const identity = await identityApi.getBackstageIdentity();
        const isGuest = identity.userEntityRef === 'user:default/guest'
          || identity.userEntityRef === 'user:development/guest';
        const isTvRoute = window.location.pathname.startsWith('/tv');
        if (isGuest && !isTvRoute) {
          window.location.href = '/tv';
        }
      } catch {
        // Not signed in yet
      }
    };
    check();
    window.addEventListener('popstate', check);
    return () => window.removeEventListener('popstate', check);
  }, [identityApi]);

  return null;
}

export const guestGuardModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootElementBlueprint.make({
      name: 'guest-guard',
      params: {
        element: <GuestRouteGuard />,
      },
    }),
  ],
});
